import React from 'react';

function Advertising({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M14 3C15.9331 3.17574 19.8521 4.6871 20.063 9.32664" />
      <path d="M10.4421 18.1791L12.3186 16.3026L14.6741 18.658C15.1922 19.1762 15.1922 20.0164 14.6741 20.5346C14.1559 21.0527 13.3157 21.0527 12.7975 20.5346L10.4421 18.1791Z" />
      <path d="M8.34375 9.35674L13.5107 14.5237L10.0525 17.9819C8.62572 19.4087 6.31238 19.4087 4.88556 17.9819C3.45873 16.5551 3.45874 14.2418 4.88556 12.8149L8.34375 9.35674Z" />
      <path d="M10.2452 4.74461C10.4648 4.23216 11.1369 4.11121 11.5214 4.51494L18.5158 11.8591C18.9033 12.266 18.7438 12.937 18.2146 13.126L13.6688 14.7495L8.2708 9.35159L10.2452 4.74461Z" />
    </svg>
  );
}

export default Advertising;
